module.exports = __webpack_public_path__ + "img/commonly.a5b93c84.png";